import React, { useEffect } from "react";
import { Link } from "gatsby";
import Volta from "../images/logos-customer/1-quote-banner/volta-quote-banner.jpg";
import Grenova from "../images/logos-customer/1-quote-banner/grenova-quote-banner.jpg";
import Lessen from "../images/logos-customer/1-quote-banner/lessen-quote-banner.jpg";
import Callahan from "../images/logos-customer/1-quote-banner/callahan-quote-banner.jpg";
import MaRS from "../images/logos-customer/1-quote-banner/mars-quote-banner.jpg";
import Sensai from "../images/logos-customer/1-quote-banner/sensai-quote-banner.png";
import ResonantLink from "../images/logos-customer/1-quote-banner/resonant-link-quote-banner.png";
import Gecko from "../images/logos-customer/1-quote-banner/gecko-quote-banner.png";
import Cheetah from "../images/logos-customer/1-quote-banner/cheetah-quote-banner.png";
import CFI from "../images/logos-customer/1-quote-banner/cfi-quote-banner.png";

// Import Swiper
import Swiper, { Pagination, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
Swiper.use([Pagination, Autoplay]);

function Testimonial({
  showTestimonial = ["volta"],
  showVOCLink = true,
  autoplay = true,
}) {
  useEffect(() => {
    const autoplayConfig = autoplay
      ? {
          delay: 5000,
          disableOnInteraction: true,
        }
      : false; // If autoplay prop is false, don't use autoplay

    // eslint-disable-next-line no-unused-vars
    const testimonial = new Swiper(".testimonial-carousel", {
      slidesPerView: 1,
      watchSlidesProgress: true,
      pagination: {
        el: ".testimonial-carousel-pagination",
        clickable: true,
      },
      autoplay: autoplayConfig,
    });
  }, [autoplay]);

  const testimonials = {
    volta: {
      name: "James Frith",
      title: "Principal",
      company: "Volta Energy Technologies",
      quote: `"The avoided emissions potential of investments in the climate space is an increasingly important metric...the Rho Impact team brings a wealth of knowledge on how to assess and report on new technologies' potential to decarbonize a range of industries and markets."`,
      image: Volta,
    },
    grenova: {
      name: "Katherine Marrs",
      title: "Chief Commercial Officer",
      company: "Grenova",
      quote: `"Our work with Rho has had a significant impact on how we view our business today and how we plan for the future. Their impact forecasting work has opened the door to new customers, new capital, and new commercial opportunities."`,
      image: Grenova,
    },
    lessen: {
      name: "Colette Temmink",
      title: "Chief Operating Officer, Commercial Division",
      company: "Lessen",
      quote: `"Rho has been an invaluable partner in supporting select ESG needs of our client base. Their depth of real-world experience, contributions to the field, and ability to work effectively across stakeholder groups has been critical in meeting the complex needs of our clients."`,
      image: Lessen,
    },
    callahan: {
      name: "Heather Holderman",
      title: "SVP",
      company: "Callahan Capital Partners",
      quote: `"Rho's expertise and capabilities are only rivaled by their passion for the work and commitment to meaningful outcomes. If you're seeking to maximize both your commercial opportunities and impact on the world, I highly recommend partnering with Rho."`,
      image: Callahan,
    },
    mars: {
      name: "Tyler Hamilton",
      title: "Senior Director, Climate",
      company: "MaRS Discovery District",
      quote:
        "Rho Impact was instrumental in helping the MaRS team calculate and communicate the GHG-reduction potential of some of Canada's most promising climate technology innovations...The kinds of tools and support Rho Impact provided took a lot of the guesswork out of our work, and allowed us back up our assumptions with data.",
      image: MaRS,
    },
    sensai: {
      name: "Ian Mathews",
      title: "CEO",
      company: "Sensai Analytics",
      quote:
        "The emissions forecasting from Rho Impact is something we have been keen to do but never had the expertise. It is great to finally get some solid numbers on our potential impact.",
      image: Sensai,
    },
    resonant_link: {
      name: "Grayson Zulauf",
      title: "CEO",
      company: "Resonant Link",
      quote: "We will definitely make use of this going forward - thank you!",
      image: ResonantLink,
    },
    gecko_robotics: {
      name: "Jake Loosararian",
      title: "CEO",
      company: "Gecko Robotics",
      quote:
        "Rho Impact's models are a game changer to help us talk about the climate impacts of our products; we are using them across sales, marketing, and fundraising.",
      image: Gecko,
    },
    cfi: {
      name: "Scott Powell",
      title: "Co-Founder, Chief Content Officer",
      company: "Corporate Finance Institute",
      quote:
        "Rho Impact has played a pivotal role in our efforts to provide top-notch education and streamlined capacity building around ESG, carbon markets, and more.",
      image: CFI,
    },
    cheetah: {
      name: "Na'ama Moran",
      title: "CEO",
      company: "Cheetah Technologies",
      quote:
        "Our ESG commitment has always been critical to the Cheetah Technologies value proposition. I recommend reaching out to Rho...it's the right thing for your company, vision, and employees.",
      image: Cheetah,
    },
  };

  return (
    <section className="relative">
      {/* Section background (needs .relative class on parent and next sibling elements) */}
      <div
        className="absolute inset-0 bg-slate-100 pointer-events-none -z-10"
        aria-hidden="true"
      ></div>

      <div className="relative max-w-6xl mx-auto mb-14 px-4 sm:px-6">
        <div className="pb-8 pt-8">
          <div className="relative">
            {/* Content */}
            <div className="relative px-6 pb-8 md:px-12 lg:pb-0">
              {/* Carousel built with Swiper.js [https://swiperjs.com/] */}
              {/* * Custom styles in src/css/additional-styles/theme.scss */}
              <div className="testimonial-carousel swiper-container ">
                <div className="swiper-wrapper">
                  {showTestimonial.map((company_name) => {
                    const testimonial = testimonials[company_name];
                    return (
                      <div
                        className="swiper-slide space-y-8 lg:flex items-center lg:space-y-0 lg:space-x-8 text-center lg:text-left"
                        key={company_name}
                      >
                        {/* Testimonial content */}
                        <div className="shrink-0 relative inline-flex">
                          <img
                            className="rounded-full"
                            src={testimonial.image}
                            width="250"
                            height="250"
                            alt="Testimonial"
                          />
                        </div>
                        <div className="relative">
                          <h4 className="h4 mb-4 font-cabinet-grotesk !font-normal">
                            {testimonial.quote}
                          </h4>
                          <span className="font-light">
                            - {testimonial.name}, {testimonial.title}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>{" "}
                {/* End swiper wrapper */}
              </div>
              {/* Bullets */}
              <div className="mt-4 z-10">
                <div className="testimonial-carousel-pagination text-center" />
              </div>
              {showVOCLink && (
                <div className="mt-8 text-center">
                  <Link
                    to="/customers"
                    className="btn btn-primary bg-white hover:bg-blue-400 hover:text-white"
                  >
                    Hear from more of our customers &rarr;
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonial;
